import { render, staticRenderFns } from "./ExtendedTables.vue?vue&type=template&id=596b2add&scoped=true"
import script from "./ExtendedTables.vue?vue&type=script&lang=js"
export * from "./ExtendedTables.vue?vue&type=script&lang=js"
import style0 from "./ExtendedTables.vue?vue&type=style&index=0&id=596b2add&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596b2add",
  null
  
)

export default component.exports